<script lang="ts">
export interface EmptyStateProps {
  class?: string | object
  label: string
  description: string
  actions?: { label: string, onClick?: () => void, icon?: string }[]
}

const ui = {
  root: 'flex flex-col items-center justify-center',
  actions: 'flex items-center gap-2 mt-3',
  wrapper: 'flex flex-col items-center justify-center gap-2',
  label: 'text-md font-semibold text-secondary-900',
  description: 'text-md text-secondary-800',
}
</script>

<script setup lang="ts">
import AwButton from './AwButton.vue'

const props = defineProps<EmptyStateProps>()
</script>

<template>
  <div :class="[ui.root, props.class]">
    <slot name="illustration" />
    <p :class="ui.wrapper">
      <span :class="ui.label">
        {{ label }}
      </span>
      <span :class="ui.description">
        {{ description }}
      </span>
    </p>
    <div v-if="actions?.length" :class="ui.actions">
      <AwButton
        v-for="action, index in actions"
        :key="index"
        :label="action.label"
        variant="outline"
        color="secondary"
        size="sm"
        :icon="action.icon"
        @click="action.onClick"
      />
    </div>
  </div>
</template>
